import * as React from 'react';

export interface IFeatureList {
  [key: string]: React.ReactNode[];
}

export const features: IFeatureList = {
  beta: [
    'Access to beta languages: Spanish (Latin America), Spanish (European), French, Italian, German, Brazilian Portuguese, Russian',
    , 'Beta languages offer custom creation of 50 vocabulary flashcards and 150 sentence flashcards'
    , 'Learn pronunciation, simple words, and grammar'
    , 'Pronunciation videos'
    , 'Ear Training'
    , 'On-boarding tutorial & contextual tooltips for guidance'
    , 'Advanced image search'
    , 'Flashcard review with Spaced Repetition'
    , 'Adaptive word frequency list'
    , 'Regular updates with new features'
  ]
};



// WEBPACK FOOTER //
// ./src/components/presentational/views/Landing/sections/Features/featuresList.ts